import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "@/lib/scrollToHash";

/**
 * When the URL has a hash (either an external deep-link like
 * `coresmith.dev/#expertise` or a cross-page nav from CommandPalette),
 * scroll to it once the page mounts and then strip the hash so a reload
 * starts at the top instead of jumping back to the anchor.
 *
 * Mounted once inside <BrowserRouter> in App.tsx.
 */
const HashScrollHandler = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    // Wait two animation frames so framer-motion entrances + useInView
    // gates have a chance to mount the target element before we measure.
    let raf1 = 0;
    const raf2 = requestAnimationFrame(() => {
      raf1 = requestAnimationFrame(() => {
        scrollToHash(hash);
      });
    });
    return () => {
      cancelAnimationFrame(raf2);
      if (raf1) cancelAnimationFrame(raf1);
    };
  }, [pathname, hash]);
  return null;
};

export default HashScrollHandler;
